if (!customElements.get('custom-product-options')) {
  customElements.define(
    'custom-product-options',
    class CustomProductOptions extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
      }

      validateCustomOptions() {
        const groups = this.querySelectorAll('customization-option');
        let isValid = true;

        const parentGroups = new Set();

        groups.forEach((group) => {
          const valid = group.validateCheckedInput();
          if (!valid) isValid = false;
          parentGroups.add(group.closest('customization-group'));
        });

        parentGroups.forEach((groupEl) => {
          const allOptions = groupEl.querySelectorAll('customization-option');
          const allChecked = Array.from(allOptions).every((option) =>
            option.querySelector('input[type="radio"]:checked')
          );

          if (!allChecked) {
            groupEl.classList.add('customization-group--required');
          }
        });

        return isValid;
      }


    }
  );
}

if (!customElements.get('customization-group')) {
  customElements.define(
    'customization-group',
    class CustomizationGroup extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.mtoDrawer = this.querySelector('drawer-content.customization-group-drawer');
        this.handleCustomATC();
        this.querySelector('#mto-back-btn')?.addEventListener('click', () => {
          this.mtoDrawer?.removeAttribute('open');

          const previousGroup = this.previousElementSibling;
          if (previousGroup?.tagName === 'CUSTOMIZATION-GROUP') {
            const previousDrawer = previousGroup.querySelector('drawer-content');
            previousDrawer?.setAttribute('open', '');
          }
        });

        this.querySelector('#mto-next-btn')?.addEventListener('click', () => {
          this.mtoDrawer?.removeAttribute('open');

          const nextGroup = this.nextElementSibling;
          if (nextGroup?.tagName === 'CUSTOMIZATION-GROUP') {
            const nextDrawer = nextGroup.querySelector('drawer-content');
            nextDrawer?.setAttribute('open', '');
          }
        });
      }

      checkIfAllOptionsFilled() {
        const allOptions = this.querySelectorAll('customization-option');
        let allFilled = true;

        allOptions.forEach((option) => {
          const checked = option.querySelector('input[type="radio"]:checked');
          if (!checked) {
            allFilled = false;
          } else {
            option.querySelectorAll('input[type="radio"]').forEach((input) => input.removeAttribute('aria-invalid'));
          }
        });

        if (allFilled) {
          this.classList.remove('customization-group--required');
        }
      }

      handleCustomATC() {
        const customATCButton = this.querySelector('#custom-atc-btn');

        if (customATCButton) {
          customATCButton.addEventListener('click', () => {
            const form = this.closest('.product-form')?.querySelector('form');
            form?.requestSubmit();

            const onCartUpdated = () => {
              if (this.mtoDrawer && this.mtoDrawer.hasAttribute('open')) {
                this.mtoDrawer.removeAttribute('open');
              }
              document.removeEventListener('cart:updated', onCartUpdated);
            };

            document.addEventListener('cart:updated', onCartUpdated);
          });
        }

      }
    }
  );
}

if (!customElements.get('customization-option')) {
  customElements.define(
    'customization-option',
    class CustomizationOption extends HTMLElement {
      constructor() {
        super();
      }
      
      connectedCallback() {
        this.updateOptionValue();
      }

      updateOptionValue() {
        this.inputs = this.querySelectorAll('input[type="radio"]');
        this.inputs.forEach((input) => {
          input.addEventListener('change', () => {
            this.querySelector('.product-form__option-value').textContent = input.value;
            this.classList.remove('customization-option--required');
            this.inputs.forEach((i) => i.removeAttribute('aria-invalid'));
            this.updateGroupSummary();
            this.closest('customization-group')?.checkIfAllOptionsFilled();
          });
        });
      }

      updateGroupSummary() {
        const group = this.closest('customization-group');
        if (!group) return;

        const labelText = group.dataset.groupName || 'Options';
        const summary = [];

        group.querySelectorAll('customization-option').forEach((option) => {
          const name = option.querySelector('.product-form__option-name')?.dataset.optionName || '';
          const selected = option.querySelector('input[type="radio"]:checked')?.value || '';
          if (name && selected) {
            summary.push(`${name}: ${selected}`);
          }
        });

        const display = summary.length ? `${labelText}: ${summary.join(', ')}` : labelText;

        const labelEl = group.querySelector('.select__selected-value-summary');
        if (labelEl) labelEl.innerText = display;

        if(group.dataset.displayMode == 'inline') {
          const inlineDisplay = summary.length ? `${summary.join(', ')}` : labelText;
          const button = group.querySelector('input.inline-properties');
          if (button) button.value = inlineDisplay;
        }
      }

      validateCheckedInput() {
        this.checkedInput = this.querySelector('input[type="radio"]:checked');
        const inputs = this.querySelectorAll('input[type="radio"]');
        let isValid = true;
        if (!this.checkedInput) {
          isValid = false;
          this.classList.add('customization-option--required');
          this.closest('customization-group').classList.add('customization-group--required');
          inputs.forEach((input) => input.setAttribute('aria-invalid', 'true'));
        } else {
          this.classList.remove('customization-option--required');
          this.closest('customization-group').classList.remove('customization-group--required');
          inputs.forEach((input) => input.removeAttribute('aria-invalid'));
        }

        return isValid;
      }

    }
  );
}

(() => {
  function setupObserver(drawer) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.attributeName === 'open') {
          const isOpen = drawer.hasAttribute('open');
          if (isOpen) {
            drawer.setAttribute('data-open', 'true');
          } else {
            setTimeout(() => {
              drawer.setAttribute('data-open', 'false');
            }, 550);
          }
        }
      }
    });

    observer.observe(drawer, { attributes: true });
  }

  function waitForDrawer() {
    const customizationGroupsDrawers = document.querySelectorAll('.customization-group-drawer');
    if (customizationGroupsDrawers.length > 0) {
      customizationGroupsDrawers.forEach((drawer) => setupObserver(drawer));
    } else {
      setTimeout(waitForDrawer, 100);
    }
  }

  waitForDrawer();
})();

